import React, { useCallback, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from "react-redux";
import ReactDOM from "react-dom";
import style from './toast.module.sass'
import { AppState } from '../../stateManager/store'



import { removeToast, deleteToast } from '../../stateManager/store/toast/actions'

interface IToast {
  type: string
  message: string
  id: string
}

export const Toast = () => {
  const intervalRef = useRef<NodeJS.Timeout | null | undefined>();

  const dispatch = useDispatch();
  const toastList: IToast[] = useSelector(
    (state: AppState) => {
      return state && state.toast && state.toast.toastList;
    },
    (prevList, currentList) => prevList.length === currentList.length
  );

  const clearTimer = useCallback(() => {
    if (toastList.length === 0 && intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, [toastList.length]);

  useEffect(() => {
    toastList.forEach(({ type }: IToast) => {
      const intervalId = setTimeout(
        () => {
          dispatch(removeToast());
        },
        type === "error" ? 5000 : 3500
      );
      intervalRef.current = intervalId;
    });

    clearTimer();
    return clearTimer;
  }, [toastList, dispatch, clearTimer]);

  const mountNode = document.getElementById("popup-root") as HTMLElement;

  // make the toast container zIndex take effect only 
  // when we have some toasts to show
  const toastStyles: React.CSSProperties = {}
  if(toastList.length) {
    toastStyles.zIndex = 1002
  }

  return ReactDOM.createPortal(
    <div className={(toastList && toastList.length) ? style.toastContainer : ""} style={toastStyles}>
      {toastList.map(
        (item: IToast, index: number) => {
          let colorClass: string;
          let title: string;
          if (item.type === "error") {
            title = "Error";
            colorClass = style.error;
          } else if (item.type === "warning") {
            title = "Warning";
            colorClass = style.warning;
          } else {
            title = "Success";
            colorClass = style.success;
          }

          return (
            <div key={index || item.id || Date.now().toString(36)} className={style.toast + " " + colorClass}>
              <span
                data-test-id={`toast_delete${item.id}`}
                className={style.toastClose}
                onClick={() => {
                  dispatch(deleteToast(item.id));
                }}
              >
                X
              </span>
              <span className={style.toastMessage}>{title}</span>
              <div className={style.toastSubMessage}>
                {typeof item.message === "string"
                  ? item.message
                  : "Unknown Error"}
              </div>
            </div>
          );
        }
      )}
    </div>,
    mountNode
  );
}
